@if (avoinna) {
  <div class="search-overlay" (mousedown)="taustaaKlikattu($event)">
    <div class="search-panel" role="dialog" aria-modal="true" cdkTrapFocus [attr.aria-label]="'tositteet.haku.modal-otsikko' | translate | async">
      <button class="search-close" type="button" (click)="sulje()" [attr.aria-label]="'tositteet.haku.sulje' | translate | async">
        <span class="material-symbols-outlined">close</span>
      </button>

      <div class="search-content">
        <div class="search-field">
          <mat-form-field>
            <mat-icon matPrefix class="listaus-haku-ikoni">search</mat-icon>
            <mat-label>{{ 'tositteet.haku.hakukentan-placeholder' | translate | async }}</mat-label>
            <input type="text" matInput #hakukentta [formField]="hakuteksti" />
          </mat-form-field>
        </div>

        <div class="filters">
          <div class="dropdown-wrap">
            <button type="button" class="filter-btn" [class.filter-btn-active]="aikavali !== 'kaikki'" (click)="vaihdaPaneeli('aikavali')">
              @if (aikavali === 'kaikki') {
                <span>{{ 'tositteet.haku.rajaa-aikavalia' | translate | async }}</span>
              } @else if (aikavali === 'mukautettu') {
                <span>{{ 'tositteet.haku.aikavali' | translate | async }} · {{ aikavalinTeksti() }}</span>
              } @else {
                <span>{{ 'tositteet.haku.aikavali' | translate | async }} · {{ 'tositteet.haku.aikavali-' + aikavali | translate | async }}</span>
              }
              <span class="filter-caret material-symbols-outlined">expand_more</span>
            </button>

            @if (avoinPaneeli() === 'aikavali') {
              <div class="dropdown aikavali-dropdown">
                @for (preset of aikavaliPresetit; track preset) {
                  <button type="button" class="dropdown-item aikavali-preset" [class.aikavali-valittu]="aikavali === preset" (click)="valitseAikavaliPreset(preset)">
                    <span>{{ 'tositteet.haku.aikavali-' + preset | translate | async }}</span>
                    @if (aikavali === preset) {
                      <span class="material-symbols-outlined aikavali-check">check</span>
                    }
                  </button>
                }

                <div class="dropdown-divider"></div>
                <div class="mukautettu-otsikko">{{ 'tositteet.haku.mukautettu-vali' | translate | async }}</div>

                <div class="date-fields">
                  <mat-form-field class="date-field">
                    <mat-label>{{ 'tositteet.haku.alkaen' | translate | async }}</mat-label>
                    <input matInput [matDatepicker]="alkuPicker" [formField]="alkuPvm" />
                    <mat-datepicker-toggle matSuffix [for]="alkuPicker"></mat-datepicker-toggle>
                    <mat-datepicker #alkuPicker></mat-datepicker>
                  </mat-form-field>

                  <mat-form-field class="date-field">
                    <mat-label>{{ 'tositteet.haku.paattyen' | translate | async }}</mat-label>
                    <input matInput [matDatepicker]="loppuPicker" [formField]="loppuPvm" />
                    <mat-datepicker-toggle matSuffix [for]="loppuPicker"></mat-datepicker-toggle>
                    <mat-datepicker #loppuPicker></mat-datepicker>
                  </mat-form-field>
                </div>

                <div class="dropdown-actions">
                  <button type="button" class="dropdown-action dropdown-action-primary" [disabled]="!alkuPvm().value() && !loppuPvm().value()" (click)="valitseAikavali()">
                    {{ 'tositteet.haku.kayta-mukautettua-valia' | translate | async }}
                  </button>
                </div>
              </div>
            }
          </div>

          @if (naytaTositelajiValinta()) {
            <div class="dropdown-wrap">
              <button type="button" class="filter-btn" [class.filter-btn-active]="tositelaji() !== oletusTositelaji" (click)="vaihdaPaneeli('tositelaji')">
                <span>{{ 'tositteet.haku.suodatin-tositelaji' | translate | async }} · {{ 'tositteet.haku.tositelaji-' + tositelaji() | translate | async }}</span>
                <span class="filter-caret material-symbols-outlined">expand_more</span>
              </button>

              @if (avoinPaneeli() === 'tositelaji') {
                <div class="dropdown">
                  <label class="dropdown-item">
                    <input type="radio" name="tositelaji" [checked]="tositelaji() === 'tositteet'" (change)="vaihdaTositelaji('tositteet')" />
                    <span>{{ 'tositteet.haku.tositelaji-tositteet' | translate | async }}</span>
                  </label>
                  <label class="dropdown-item">
                    <input type="radio" name="tositelaji" [checked]="tositelaji() === 'ostolaskut'" (change)="vaihdaTositelaji('ostolaskut')" />
                    <span>{{ 'tositteet.haku.tositelaji-ostolaskut' | translate | async }}</span>
                  </label>
                  <label class="dropdown-item">
                    <input type="radio" name="tositelaji" [checked]="tositelaji() === 'molemmat'" (change)="vaihdaTositelaji('molemmat')" />
                    <span>{{ 'tositteet.haku.tositelaji-molemmat' | translate | async }}</span>
                  </label>
                </div>
              }
            </div>
          }

          <div class="dropdown-wrap">
            <button type="button" class="filter-btn" [class.filter-btn-active]="valitutToimittajat.size > 0" (click)="vaihdaPaneeli('toimittaja')">
              @if (valitutToimittajat.size > 0) {
                <span>{{ 'tositteet.haku.suodatin-toimittaja' | translate | async }} · {{ valitutToimittajat.size }}</span>
              } @else {
                <span>{{ 'tositteet.haku.suodatin-toimittaja' | translate | async }}</span>
              }
              <span class="filter-caret material-symbols-outlined">expand_more</span>
            </button>

            @if (avoinPaneeli() === 'toimittaja') {
              <div class="dropdown">
                @for (t of kaikkiToimittajat(); track t.avain) {
                  <label class="dropdown-item">
                    <input type="checkbox" [checked]="onkoToimittajaValittu(t.avain)" (change)="vaihdaToimittaja(t.avain)" />
                    <span>{{ t.nimi }}</span>
                  </label>
                }
                @if (valitutToimittajat.size > 0) {
                  <button type="button" class="dropdown-clear" (click)="tyhjennaToimittajat()">
                    {{ 'tositteet.haku.tyhjenna-valinnat' | translate | async }}
                  </button>
                }
              </div>
            }
          </div>

          <div class="dropdown-wrap">
            <button type="button" class="filter-btn" [class.filter-btn-active]="valitutMaksutavat.size > 0" (click)="vaihdaPaneeli('maksutapa')">
              @if (valitutMaksutavat.size > 0) {
                <span>{{ 'tositteet.haku.suodatin-maksutapa' | translate | async }} · {{ valitutMaksutavat.size }}</span>
              } @else {
                <span>{{ 'tositteet.haku.suodatin-maksutapa' | translate | async }}</span>
              }
              <span class="filter-caret material-symbols-outlined">expand_more</span>
            </button>

            @if (avoinPaneeli() === 'maksutapa') {
              <div class="dropdown">
                @if (kaikkiMaksutavat().length === 0) {
                  <div class="dropdown-empty">{{ 'tositteet.haku.ei-maksutapoja' | translate | async }}</div>
                } @else {
                  @for (m of kaikkiMaksutavat(); track m.i) {
                    <label class="dropdown-item">
                      <input type="checkbox" [checked]="onkoMaksutapaValittu(m.i)" (change)="vaihdaMaksutapa(m.i)" />
                      <span>{{ m.l }}</span>
                    </label>
                  }
                  @if (valitutMaksutavat.size > 0) {
                    <button type="button" class="dropdown-clear" (click)="tyhjennaMaksutavat()">
                      {{ 'tositteet.haku.tyhjenna-valinnat' | translate | async }}
                    </button>
                  }
                }
              </div>
            }
          </div>

          @if (naytaProjektitSuodatin()) {
            <div class="dropdown-wrap">
              <button type="button" class="filter-btn" [class.filter-btn-active]="valitutProjektit().size > 0" (click)="vaihdaPaneeli('projekti')">
                @if (valitutProjektit().size > 0) {
                  <span>{{ 'tositteet.haku.suodatin-projekti' | translate | async }} · {{ valitutProjektit().size }}</span>
                } @else {
                  <span>{{ 'tositteet.haku.suodatin-projekti' | translate | async }}</span>
                }
                <span class="filter-caret material-symbols-outlined">expand_more</span>
              </button>

              @if (avoinPaneeli() === 'projekti') {
                <div class="dropdown">
                  @for (p of kaikkiProjektit(); track p.avain) {
                    <label class="dropdown-item">
                      <input type="checkbox" [checked]="onkoProjektiValittu(p.avain)" (change)="vaihdaProjekti(p.avain)" />
                      <span>{{ p.nimi }}</span>
                    </label>
                  }
                  @if (valitutProjektit().size > 0) {
                    <button type="button" class="dropdown-clear" (click)="tyhjennaProjektit()">
                      {{ 'tositteet.haku.tyhjenna-valinnat' | translate | async }}
                    </button>
                  }
                </div>
              }
            </div>
          }
        </div>

        @if (aikavali !== 'kaikki' || valitutMaksutavat.size > 0 || valitutProjektit().size > 0 || valitutToimittajat.size > 0) {
          <div class="chips">
            @if (aikavali !== 'kaikki') {
              <span class="filter-chip">
                {{ 'tositteet.haku.aikavali' | translate | async }} ·
                @if (aikavali === 'mukautettu') {
                  {{ aikavalinTeksti() }}
                } @else {
                  {{ 'tositteet.haku.aikavali-' + aikavali | translate | async }}
                }
                <button type="button" (click)="poistaAikavali()" [attr.aria-label]="'tositteet.haku.poista-suodatin' | translate | async">
                  <span class="material-symbols-outlined">close</span>
                </button>
              </span>
            }
            @for (item of valitutToimittajatLista; track item.avain) {
              <span class="filter-chip">
                {{ 'tositteet.haku.chip-toimittaja-prefix' | translate | async }} · {{ item.nimi }}
                <button type="button" (click)="poistaToimittajaValinta(item.avain)" [attr.aria-label]="'tositteet.haku.poista-suodatin' | translate | async">
                  <span class="material-symbols-outlined">close</span>
                </button>
              </span>
            }
            @for (item of valitutMaksutavatLista; track item.tunniste) {
              <span class="filter-chip">
                {{ 'tositteet.haku.chip-maksutapa-prefix' | translate | async }} · {{ item.nimi }}
                <button type="button" (click)="poistaMaksutapaValinta(item.tunniste)" [attr.aria-label]="'tositteet.haku.poista-suodatin' | translate | async">
                  <span class="material-symbols-outlined">close</span>
                </button>
              </span>
            }
            @for (item of valitutProjektitLista; track item.avain) {
              <span class="filter-chip">
                {{ 'tositteet.haku.chip-projekti-prefix' | translate | async }} · {{ item.nimi }}
                <button type="button" (click)="poistaProjektiValinta(item.avain)" [attr.aria-label]="'tositteet.haku.poista-suodatin' | translate | async">
                  <span class="material-symbols-outlined">close</span>
                </button>
              </span>
            }
          </div>
        }

        <div class="results">
          @if (haetaan()) {
            <div class="hint">{{ 'tositteet.haku.haetaan' | translate | async }}</div>
          } @else if (!onkoHakuehtoja) {
            <div class="hint">{{ 'tositteet.haku.ohje-alkutila' | translate | async }}</div>
          } @else if (tulokset().length === 0) {
            <div class="hint">{{ 'tositteet.haku.ei-tuloksia' | translate | async }}</div>
          } @else {
            <app-tosite-lista [rivit]="tulokset()" [esitystapa]="esitystapa" [projektitMap]="projektitMap()" [sorttausKaytossa]="false" (riviKlikattu)="avaaTosite($event)"></app-tosite-lista>
            <mat-paginator class="haku-paginator" [length]="kokonaismaara()" [pageIndex]="sivu()" [pageSize]="sivunKoko" [pageSizeOptions]="sivukoot" showFirstLastButtons (page)="sivuMuuttui($event)"></mat-paginator>
          }
        </div>
      </div>
    </div>
  </div>
}
